@let request = confirm.request();
<ui-modal [isOpen]="!!request" size="sm" variant="warning" [title]="request?.title"
  (closed)="confirm.answer(false)">
  @if (request) {
  <div modal-body class="space-y-4 pb-4">
    <p class="text-sm text-[var(--text-light-gray)]">{{ request.message }}</p>
    <div class="flex justify-end gap-3">
      <ma-button [label]="request.cancelLabel" variant="text" (click)="confirm.answer(false)" />
      <ma-button [label]="request.confirmLabel" variant="primary" (click)="confirm.answer(true)" />
    </div>
  </div>
  }
</ui-modal>
